var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('sub-staff-top', [_c('v-row', [_c('v-col', {
    staticClass: "mb-50 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.image,
      "alt": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7",
      "offset-lg": "1"
    }
  }, [_c('div', {
    staticClass: "w-100 d-sm-flex align-end justify-space-between mb-30 mb-md-70 mb-lg-110"
  }, [_c('div', [_c('p', {
    staticClass: "color-point page-text line-height-1 mb-6 mb-lg-20"
  }, [_vm._v(_vm._s(_vm.position))]), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold line-height-1 mr-8 mr-lg-20"
  }, [_vm._v(_vm._s(_vm.name))]), _vm.instagram ? _c('v-btn', {
    staticClass: "insta",
    attrs: {
      "large": "",
      "icon": "",
      "href": _vm.instagram,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon icon-insta"
  })]) : _vm._e()], 1)]), _c('v-btn', {
    staticClass: "min-w-180px min-w-lg-240px mt-20 mt-sm-0",
    attrs: {
      "to": "/inquiry",
      "large": "",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "d-flex justify-space-between align-center w-100"
  }, [_vm._v(" 문의하기 "), _c('i', {
    staticClass: "icon icon-right-arrow"
  })])])], 1), _vm._l(_vm.items, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-6 mb-lg-10"
    }, [_c('v-row', {
      staticClass: "row--small"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c('p', {
      staticClass: "page-text--lg font-weight-bold"
    }, [_vm._v(_vm._s(item.subject))])]), _c('v-col', {
      staticClass: "mt-n10 mt-md-0",
      attrs: {
        "cols": "12",
        "md": "9"
      }
    }, [_c('div', {
      staticClass: "ml-lg-4"
    }, _vm._l(item.content, function (text, index) {
      return _c('p', {
        key: index,
        staticClass: "page-text dot-text color-grey",
        class: {
          'mt-2 mt-lg-8': index !== 0
        }
      }, [_vm._v("· " + _vm._s(text))]);
    }), 0)])], 1)], 1);
  })], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }